module.exports = __webpack_public_path__ + "img/bg_rooftop.8816d22a.jpg";